import React, {useState, useEffect, ReactElement} from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/hooks";
import { selectCommittees, updateConfig } from "../../../lib/slices/appConfig";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import data from "../../../lib/data";
import Api from "../../../lib/Api";

import "./LegislationConfig.css";

export default function LegislationConfig() {

    const [showConfig, setShowConfig] = useState(false);
    const [filters, setFilters] = useState<string[]>([]);
    const [notifyOnNew, setNotifyOnNew] = useState(false);
    const [selectedCommitteeId, setSelectedCommitteeId] = useState(-1);

    const freeCommitteeLimit = 4;
    const isPremium = true;

    const committees = useAppSelector(selectCommittees);

    const dispatch = useAppDispatch();

    // useEffect(() => {
    //     console.log("UseEffect", committees);
    // }, [committees])

    function addFilter(event: any) {
        let _filters = [...filters];
        _filters.push("");
        setFilters(_filters);
    }

    function updateFilter(id: number, text: string) {
        let _filters = [...filters];
        _filters[id] = text;
        setFilters(_filters);
    }

    function removeFilter(id: number) {
        let _filters = [...filters];
        _filters.splice(id, 1);
        setFilters(_filters);
    }

    function loadCommittee(id: number) {
        if(committees && committees.length > 0) {
            setSelectedCommitteeId(committees[id].CommitteeId);
            setNotifyOnNew(committees[id].NotifyOnNewLegislation);
            setFilters(committees[id].NotificationFilters);
        }
    }

    function unloadCommittee() {
        setSelectedCommitteeId(-1);
        setNotifyOnNew(false);
        setFilters([]);
    }
    
    async function saveConfig() {
        // let select= (document.getElementById("committee-select") as HTMLInputElement);
        // let id = parseInt(select.value);
        const id = selectedCommitteeId;
        if (id == -1)
            return
        let committee: {id: number, name: string} = {id: -1, name: ""};
        data.comisions.forEach((elem) => {
            if (elem.id == id) {
                committee = elem
                return
            }
        });

        if(committee.id == -1)
            return
        
        let _committees = [...committees];
        let _filters = [...filters];
        let _notifyOnNew = notifyOnNew;

        const save = async () => {
            const found = _committees.find((e) => e.CommitteeId == committee.id);

            if(found) {
                for(let i=0; i < _committees.length; i++) {
                    if(_committees[i].CommitteeId == found.CommitteeId) {
                        const _committee = {
                            AdministrationId: 2025,
                            CommitteeId: committee.id,
                            NotifyOnNewLegislation: _notifyOnNew,
                            NotificationFilters: _filters
                        }
                        _committees[i] = _committee;
                    }
                }
                _committees = [..._committees]
            }
            else {
                const _committee = {
                    AdministrationId: 2025,
                    CommitteeId: committee.id,
                    NotifyOnNewLegislation: _notifyOnNew,
                    NotificationFilters: _filters
                }
                _committees.push(_committee);
            }
            
            const configResult = await Api.updateCommitteeConfig(_committees);
            if(!configResult.Error) {
                const config = configResult.Data;
                if(config) {
                    dispatch(updateConfig(config));
                }
            }

            setSelectedCommitteeId(-1);
            setFilters([]);
            setNotifyOnNew(false);
        }

        if (isPremium) {
            await save();
        }
        else {
            if(committees.length < freeCommitteeLimit) {
                await save();
            }
        }

    }

    async function removeCommittee(adminId: number, committeeId: number) {
        
        const _committees = [...committees];
        for(let i=0; i < _committees.length; i++) {
            if(_committees[i].AdministrationId == adminId &&
                _committees[i].CommitteeId == committeeId) {
                    _committees.splice(i,1);
                    break;
            }
        }

        const configResult = await Api.updateCommitteeConfig(_committees);
        if(!configResult.Error) {
            const config = configResult.Data;
            if(config) {
                dispatch(updateConfig(config));
            }
        }
    }

    function getCommitteeName(committeeId: number) {
        const found = data.comisions.find((e) => e.id == committeeId);
        if(found)
            return found.name;
        return ""
    }

    return (
        <>
            <div className='legislation-settings-header-container'>
                <div className='legislation-settings-header-item'  onClick={() => {setShowConfig(!showConfig); unloadCommittee(); }}>
                    <div role="button" className="button">Configurar Alertas de Legislaci&oacute;n <FontAwesomeIcon icon="gear" /></div>
                </div>
            </div>
            {
                committees && committees.length == 0?
                <div className="legislation-settings-container">
                    <div>
                        Configure las comisiones legislativas para las cuales que desea ver legislación presionando el icono de engranaje (<FontAwesomeIcon icon="gear" />)
                    </div>
                </div> : <></>
            }
            {
                showConfig?                    
                    <div className="legislation-settings-container">
                        <div className="legislation-settings-items-container">
                            <div>
                                <select className="committee-select" disabled={true}>
                                    <option value="2025">2025-2028</option>
                                </select>
                            </div>
                        </div>
                        <div className="legislation-settings-items-container">
                            <div>
                                <select id="committee-select" value={selectedCommitteeId} onChange={(e) => setSelectedCommitteeId(parseInt(e.target.value))} className="committee-select">
                                    <option value="-1">Seleccione una Comisi&oacute;n</option>
                                    {data.comisions.map(element => {
                                        return (
                                            <option key={element.id} value={element.id}>{element.name}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="legislation-settings-items-container">
                            <input type="checkbox" checked={notifyOnNew} onChange={(e) => setNotifyOnNew(e.target.checked)}  id="notifyOnNew" />
                            <label htmlFor="notifyOnNew">Marca para notificar sobre legislaci&oacute;n nueva.</label>
                        </div>
                        <div className="legislation-settings-items-container">
                            <div>
                                <label>Establezca los filtros aplicables a la legislaci&oacute;n</label>
                            </div>
                            <div className="sm-form-button" onClick={(e) => addFilter(e)}>
                                A&ntilde;adir Filtro
                            </div>
                        </div>
                        {
                            filters.map((val, i) => {
                                return (
                                    <div key={`filter_${i}`} className="legislation-settings-items-container">
                                        <input type="text" onChange={(e) => updateFilter(i, e.target.value)} className="textbox" value={val} name="filters" placeholder="Filtro" />
                                        <FontAwesomeIcon icon={faCircleXmark} onClick={() => removeFilter(i)} />
                                    </div>
                                )
                            })
                        }
                        <div className="legislation-settings-items-container">
                            <div className="form-button" onClick={async () => await saveConfig()}>
                                Guardar
                            </div>
                        </div>
                        <br />
                        <div className="selected-committee-container">
                            {
                                committees.map((elem, i) => {
                                    return (
                                        <div key={elem.CommitteeId} className="selected-committee-item">
                                            <div className={selectedCommitteeId == elem.CommitteeId? "committee-button committee-selected selected-committee-item-active" : "committee-button committee-selected"} onClick={() => loadCommittee(i)}>{getCommitteeName(elem.CommitteeId)}</div>
                                            <FontAwesomeIcon style={{cursor: "pointer"}} onClick={() => removeCommittee(elem.AdministrationId, elem.CommitteeId)} icon={faCircleXmark} />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}